export default "__VITE_ASSET__DmH_ST9U__"